
import { StoreActionType as Type } from "../../types"; 
 
const initialState: any = {
    activeIndexNumber: 1 
}; 

export const activeIndexNumberReducer: any = (state: any = initialState, action: any) => {
   switch (action?.type) {
    case Type.SET_CONTENT:
      return {
        ...state,
        activeIndexNumber: action?.payload?.activeIndexNumber,
      };

    default:
      return state;
  }
};
